module.exports = __webpack_public_path__ + "static/img/create_success.88be634f.png";